module.exports = __webpack_public_path__ + "img/other2.5507fd6d.png";